var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759H734V905H479V609h255V391q0-186 104-288.5T1115 0q147 0 228 12z","fill":"currentColor"}));
}

Facebook.defaultProps = {"viewBox":"0 0 1792 1792"};

module.exports = Facebook;

Facebook.default = Facebook;
